import { render, staticRenderFns } from "./ChildrenModules.vue?vue&type=template&id=147a2b0a&"
import script from "./ChildrenModules.vue?vue&type=script&lang=js&"
export * from "./ChildrenModules.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenModules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports